var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-2 d-flex",class:_vm.isOdd ? 'ODD': 'EVEN'},[_c('div',{staticClass:"MESSAGE",domProps:{"innerHTML":_vm._s(_vm.message)},on:{"click":_vm.handleClick}})])
}
var staticRenderFns = []

export { render, staticRenderFns }